document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper1', {
    slidesPerView: 4,
    breakpoints: {
      320: { slidesPerView: 2, spaceBetween: 20 },
      480: { slidesPerView: 3, spaceBetween: 30 },
      640: { slidesPerView: 4, spaceBetween: 40 },
    },
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  });

  const swiper1 = new Swiper('.swiper2', {
    slidesPerView: 4,
    breakpoints: {
      320: { slidesPerView: 2, spaceBetween: 20 },
      480: { slidesPerView: 3, spaceBetween: 30 },
      640: { slidesPerView: 4, spaceBetween: 40 },
    },
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  });
});
$(document).ready(function(){
  $(".product-form__quantity, .product-buy-button").wrapAll("<div class='qunatity-and-atc'/>")
  $(".ingredient-header").on("click", function(){
    $(this).parents(".ingredient-item").find(".ingredient-description").slideToggle();
  })
  
})



$(document).ready(function () {
  $(".subscription-widget label input").on("change", function(){
    if ($(this).is(":checked"))
    {
      $(this).siblings("span.checkbox-custom").addClass("active-check");
      
    }
    else
    {
      $(this).siblings("span.checkbox-custom").removeClass("active-check");
    }
  })
  $(document).on("click", ".subscription-widget-cart label ",  function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).find("span.checkbox-custom").toggleClass("active-check");
    if ($(this).find("span.checkbox-custom").hasClass("active-check"))
    {
      
      $("#subscription-frequency-cart").show();
    }
    else
    {
      //$(this).siblings("span.checkbox-custom").removeClass("active-check");
      $("#subscription-frequency-cart").hide();
    }
  })
  $(document).on('change', '.subscription-toggle', function () {
    var $select = $(this);
    var sellingPlanId = $select.val();
    var lineIndex = parseInt($select.data('line'), 10);
    var itemKey = $select.data('key');
    console.log(lineIndex)
    // Find the quantity for this item
    var quantity = parseInt($(this).parents(".cart-item").find(".quantity__input").val()); // default fallback
    var $item = $(`.cart-item[data-key="${itemKey}"]`);
    var qtyInput = $item.find('input.quantity__input');
    // if (qtyInput.length) {
    //   quantity = parseInt(qtyInput.val(), 10);
    // }
    console.log(quantity)

    var dataPayload = {
      line: lineIndex,
      quantity: quantity,
      selling_plan: sellingPlanId ? parseInt(sellingPlanId) : null
    };

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      contentType: 'application/json',
      data: JSON.stringify(dataPayload),
      success: function (cart) {
        console.log("Product changed")
        //Reload just the cart drawer section
        fetch(`/?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
        // $.get('/?section_id=cart-drawer', function (data) {
        //   var $newDrawer = $(data).find('#shopify-section-cart-drawer');
        //   $('#shopify-section-cart-drawer').html($newDrawer.html());
        // });
      },
      error: function (xhr) {
        console.error('Error:', xhr.responseJSON || xhr.responseText);
        alert('Something went wrong while updating your subscription.');
      }
    });
  });
});